import { TInvalidAccessErrorFactory } from '../types';

export const createInvalidAccessError: TInvalidAccessErrorFactory = () => new DOMException('', 'InvalidAccessError');
